// @flow

import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { verifyEmail, requestVerifyEmail } from '../../actions/auth';
import authService from '../../services/auth-service';
import Message from '../shared/Message';
import Button from '../shared/Button';
import PublicView from '../layouts/PublicView';
import type { AuthState } from '../../store/reducers/auth';

type Props = {
  requestVerifyEmail: () => void,
  verifyEmail: (token: string) => void,
  auth: AuthState,
  history: {
    push: (string) => void
  },
  match: {
    params: {
      token: string
    }
  }
} & WithTranslation

class VerifyEmail extends Component<Props> {
  props: Props

  reRequest = () => {
    this.props.requestVerifyEmail();
  }

  componentWillMount() {
    this.props.verifyEmail(this.props.match.params.token);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.auth.message) {
      if (this.props.auth.message !== nextProps.auth.message) {
        setTimeout(() => {
          this.props.history.push('/');
        }, 1000);
      }
    }
  }

  render() {
    const { t, i18n, auth } = this.props;
    return (
      <PublicView
        className='verify-email'
        viewType='public-body'
      >
        {!auth.loading &&
          <div>
            <div className='mb2'>
              {(auth.error && auth.error.length > 0) ? (
                <Message className='danger'>
                  {auth.error[0].message}
                </Message>
              ) : ''}
            </div>
            <div className='mb2'>
              {auth.code && auth.message ? (
                <Message className=''>
                  {i18n.exists(`verifyEmail:${auth.code}`) ? t(auth.code) : auth.message}
                </Message>
              ) : ''}
            </div>
            {authService.loggedIn && auth.error.length > 0 &&
              <Button isPrimary onClick={this.reRequest}>{t('send_new_link')}</Button>
            }
          </div>
        }
      </PublicView>
    );
  }
}

const mapStateToProps = (appState) => ({
  auth: appState.auth,
  user: appState.user
});

export default withTranslation('verifyEmail')(connect(mapStateToProps, {
  verifyEmail,
  requestVerifyEmail
})(VerifyEmail));



// WEBPACK FOOTER //
// ./src/components/pages/verify-email.js